<template>
  <div class="teams-promo-wrapper">
    <button @click.stop.prevent="open" data-testid="invite-team-members-btn" class="teams-promo-button">
      <Icon name="general.plus" size="base" />
      Invite team members
    </button>
  </div>
</template>

<script lang="ts" setup>
import { useModal } from '@/storybook/modal/useModal';
import InviteModal from '../InviteModal.vue';
import Icon from '@/storybook/icon/Icon.vue';
import './sidebar.css';
const { open } = useModal(InviteModal);
</script>

<style scoped></style>
